export enum LeaseOptionType {
  RENEWAL = 1,
  EXPANSION = 2,
  TENANT_TERMINATION = 3,
  LANDLORD_TERMINATION = 4,
  MUTUAL_TERMINATION = 5,
}
